import { computed, reactive } from "vue";

import { api, apiPrefix } from "../api/client.js";

export const session = reactive({
  loading: true,
  user: null,
  plan: null,
  language: "en",
  timezone: null,
  effectiveTimezone: "UTC",
  // plan gates for Maya (mirrors the pre-Vue app's MAYA.canChat / MAYA.canExec)
  canChat: true,
  canExec: true,
  partnerProgram: false,
});
export const lang = computed(() => session.language);

let pending;
let timezoneSyncPending = false;

export async function loadSession() {
  if (pending) return pending;
  session.loading = true;
  pending = api("/api/me")
    .then((data) => {
      session.user = data.user || null;
      session.plan = data.plan || null;
      session.language = data.lang || "en";
      session.timezone = data.timezone || null;
      session.effectiveTimezone = data.effectiveTimezone || data.timezone || "UTC";
      if (data.timezone === null && !timezoneSyncPending) {
        const browserTimezone = typeof Intl !== "undefined" && typeof Intl.DateTimeFormat === "function" ? Intl.DateTimeFormat().resolvedOptions().timeZone || "" : "";
        if (browserTimezone) {
          timezoneSyncPending = true;
          api("/api/me/timezone", { method: "POST", json: { timezone: browserTimezone, source: "browser" } })
            .then((result) => {
              session.timezone = result.timezone || browserTimezone;
              session.effectiveTimezone = session.timezone;
            })
            .catch(() => {})
            .finally(() => { timezoneSyncPending = false; });
        }
      }
      session.canChat = data.chat !== false;
      session.canExec = data.exec !== false;
      session.partnerProgram = data.partner_program === true;
      return session.user;
    })
    .finally(() => {
      session.loading = false;
      pending = null;
    });
  return pending;
}

export function loginUrl() {
  return `${apiPrefix()}/login.html`;
}

const LOGOUT_KEYS = ["soa_pending_scan", "soa_onb", "soa_onb_b", "soa_onb_k", "soa_onb_bid", "soa_onb_ans"];

export async function logout() {
  // don't leak one account's intake to the next user on a shared browser (pre-Vue parity)
  for (const key of LOGOUT_KEYS) { try { localStorage.removeItem(key); } catch { /* storage optional */ } }
  await api("/api/auth/logout", { method: "POST" });
  session.user = null;
  session.plan = null;
  window.location.assign(loginUrl());
}
